import { useApi } from './useApi'

const BASE_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000'

export const useAlojamientos = () => {
  const api = useApi()

  // { alojamientos: [{ id, guestGroupId, nombre, whatsapp, ubicacion, cantidad, vehiculo }] }
  const getAlojamientos = () => api.get('/api/alojamientos')

  const createAlojamiento = (payload) => api.post('/api/alojamientos', payload)

  const updateAlojamiento = (id, payload) => api.put(`/api/alojamientos/${id}`, payload)

  const deleteAlojamiento = (id) => api.del(`/api/alojamientos/${id}`)

  const getPublicUrl = (token) =>
    `${window.location.origin}/alojamiento-publico?token=${token}`

  const getAlojamientoLink = () => api.get('/api/alojamiento-link')

  const createAlojamientoLink = () => api.post('/api/alojamiento-link', {})

  const revokeAlojamientoLink = () => api.del('/api/alojamiento-link')

  const fetchPublicAlojamientoInfo = async (token) => {
    const res = await fetch(`${BASE_URL}/api/public/alojamiento/${token}`)
    return res.json()
  }

  const submitPublicAlojamiento = async (token, payload) => {
    const res = await fetch(`${BASE_URL}/api/public/alojamiento/${token}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
    return res.json()
  }

  return {
    getAlojamientos,
    createAlojamiento,
    updateAlojamiento,
    deleteAlojamiento,
    getPublicUrl,
    getAlojamientoLink,
    createAlojamientoLink,
    revokeAlojamientoLink,
    fetchPublicAlojamientoInfo,
    submitPublicAlojamiento,
  }
}
